'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const ReportComparisonChart = dynamic(() => import('./ReportComparisonChart'), { ssr: false });
const ReportTrendChart = dynamic(() => import('./ReportTrendChart'), { ssr: false });

export default function ReportChartsSection() {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-3 2xl:grid-cols-3 gap-4">
      <div className="xl:col-span-2 bg-card border border-border rounded-xl p-5">
        <div className="mb-4">
          <h2 className="text-base font-600 text-foreground" style={{ fontWeight: 600 }}>
            Teacher Accountability Comparison — May 2026
          </h2>
          <p className="text-xs text-muted-foreground mt-0.5">
            Attendance rate, punctuality rate, and deportment compliance per teacher. Dashed line = 90% threshold.
          </p>
        </div>
        <ReportComparisonChart />
      </div>
      <div className="bg-card border border-border rounded-xl p-5">
        <div className="mb-4">
          <h2 className="text-base font-600 text-foreground" style={{ fontWeight: 600 }}>
            School-Wide Trend — 2026
          </h2>
          <p className="text-xs text-muted-foreground mt-0.5">
            Monthly average for attendance, punctuality, and deportment compliance.
          </p>
        </div>
        <ReportTrendChart />
      </div>
    </div>
  );
}